import { render, staticRenderFns } from "./WarehouseHours.vue?vue&type=template&id=2d845a21"
import script from "./WarehouseHours.vue?vue&type=script&lang=js"
export * from "./WarehouseHours.vue?vue&type=script&lang=js"
import style0 from "./WarehouseHours.vue?vue&type=style&index=0&id=2d845a21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports